export default __webpack_public_path__ + "img/dRrkBuqe.8352af59.svg";